/* 
Model defined for Maintaining Permission Responses. It can also be used for transferring model
*/
export class CurrencyModel {
    buyPriceInINR: number;
    buyPriceInUSD: number;
    currencyCode: string;
    currencyName: string;
    dateTime: number;
    salePriceInINR: number;
    salePriceInUSD: number;
}



// WEBPACK FOOTER //
// ./src/app/_models/rates/CurrencyModel.ts